export const INDEX_REWRITER_ZIP_NAME = 'index-rewriter-lambda.zip'
